import React, { useState, useEffect } from "react";
import "../styles/Pages.css";

// Generate wallpaper data for wall-01.jpg to wall-35.jpg
const sampleWallpapers = Array.from({ length: 35 }, (_, i) => {
  const num = String(i + 1).padStart(2, "0");
  return {
    id: i + 1,
    filename: `wall-${num}.jpg`,
    thumbnail: `/image/wallpaper/thumbnail/wall-${num}.jpg`,
    fullImage: `/image/wallpaper/wall-${num}.jpg`,
    alt: `Wallpaper ${i + 1}`,
  };
});

function Wallpaper() {
  // Sample wallpaper data - in production, this would come from an API or backend
  const [wallpapers, setWallpapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading wallpapers
    setTimeout(() => {
      setWallpapers(sampleWallpapers);
      setLoading(false);
    }, 500);
  }, []);

  const handleDownload = (e, wallpaper) => {
    // Add click animation effect
    const btn = e.currentTarget;
    btn.style.transform = "scale(0.95)";
    setTimeout(() => {
      btn.style.transform = "scale(1)";
    }, 100);
  };

  const formatAltText = (filename) => {
    // Convert filename to readable text (e.g., "wallpaper-name.jpg" -> "Wallpaper Name")
    const nameWithoutExt = filename.replace(/\.[^/.]+$/, "");
    return nameWithoutExt
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <main className="page-content">
      <div className="page-header">
        <h1>Mobile Wallpaper</h1>
        <p className="header-subtitle">
          Download beautiful wallpapers for your mobile device
        </p>
      </div>

      <div className="page-body">
        {loading ? (
          <div className="wallpaper-loading">
            <p>Loading wallpapers...</p>
          </div>
        ) : wallpapers.length > 0 ? (
          <div className="gallery-container">
            {wallpapers.map((wallpaper) => (
              <div className="gallery-item" key={wallpaper.id}>
                <a
                  href={wallpaper.fullImage}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gallery-image-link"
                >
                  <img
                    src={wallpaper.thumbnail}
                    alt={wallpaper.alt || formatAltText(wallpaper.filename)}
                    loading="lazy"
                    onError={(e) => {
                      // Fallback to full image if thumbnail not found
                      e.target.src = wallpaper.fullImage;
                    }}
                  />
                </a>
                <a
                  href={wallpaper.fullImage}
                  download={wallpaper.filename}
                  className="download-btn"
                  onClick={(e) => handleDownload(e, wallpaper)}
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-wallpapers">
            <p>No wallpapers found.</p>
          </div>
        )}
      </div>
    </main>
  );
}

export default Wallpaper;
